<template>
<div>
  <component
    :is='isSubMenu ? "ElSubmenu" : "ElMenuItem"'
    :index="menu.id"
    @click="$emit('changeMenu', menu)"
  >
    <template v-if="isSubMenu">
      <template slot="title">
        <img v-if="rx.test(menu.icon)" class='menu-icon' :src="menu.icon" alt="">
        <i v-else-if='menu.icon' class='menu-icon' :class="menu.icon"></i>
        <span slot="title">{{ menu.rawName || t(menu.name) }}</span>
      </template>
      <menu-item v-for='_menu in menu.children' :menu='_menu' :key='_menu.id' @changeMenu="$emit('changeMenu', _menu)"/>
    </template>

    <template v-else>
      <img v-if="rx.test(menu.icon)" class='menu-icon' :src="menu.icon" alt="">
      <i v-else-if='menu.icon' class='menu-icon' :class="menu.icon"></i>
      <span slot="title">{{ menu.rawName || t(menu.name) }}</span>
    </template>
  </component>
</div>
</template>

<script>
import Locale from '../../mixins/locale'
export default {
  name: 'MenuItem',
  mixins: [Locale],
  computed: {
    isSubMenu () {
      return !!(this.menu.children && this.menu.children.length)
    }
  },
  data () {
    return {
      rx: /^data:image/
    }
  },
  props: {
    menu: Object
  }
}
</script>

<style scoped lang='scss'>
.menu-icon {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 20px;
  margin-left: -4px;
  color: #fff;
}
</style>